import { MouseEvent, useCallback } from 'react'

import {
  knowledgeBaseKeyFromUrl,
  openKnowledgeBase,
} from '@/lib/misc/knowledgeBase'
import { useKnowledgeBase } from '@/lib/provider/KnowledgeBaseProvider'
import { useKnowledgeBaseCatalogue } from '@/lib/queries/KnowledgeBase.queries'

export interface KnowledgeBaseLinkProps {
  href: string
  target: '_blank'
  onClick: (event: MouseEvent<HTMLElement>) => void
}

const isPlainClick = (event: MouseEvent<HTMLElement>) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey

export const useKnowledgeBaseLink = (): ((
  url: string
) => KnowledgeBaseLinkProps) => {
  const { isEnabled } = useKnowledgeBase()
  const { documents } = useKnowledgeBaseCatalogue(isEnabled)

  return useCallback(
    (url: string) => {
      const key = isEnabled ? knowledgeBaseKeyFromUrl(url, documents) : null
      return {
        href: url,
        target: '_blank',
        onClick: (event: MouseEvent<HTMLElement>) => {
          if (key == null || event.defaultPrevented || !isPlainClick(event)) {
            return
          }
          event.preventDefault()
          openKnowledgeBase(key)
        },
      }
    },
    [isEnabled, documents]
  )
}
